import React from 'react';
import Product from '../../../features/product';
import { shelfContent } from '../../../../constants/copyright';
import { useProducts } from '../../../../redux/reducer/content';

const { animationDelay } = shelfContent;

const ShelfItems = React.forwardRef(function ShelfItems() {
  const { productsFromGA } = useProducts();

  return (
    <div className={'shelf__items'}>
      {productsFromGA?.map?.((item, index) => (
        <div className={'shelf__item'} style={{ '--delay': animationDelay(index) }} key={`product-${index}`}>
          <Product className={'product_quiz product_quiz-gray product_shelf'} noCode={true} {...item} />
        </div>
      ))}
    </div>
  );
});
export default ShelfItems;
ShelfItems.propTypes = {};
